import React from 'react'
import PropTypes from 'prop-types'

import Count from './common/Count'
import TimeAgo from './common/TimeAgo'

const Boards = ({edges, pageInfo, onLoadMore}) => {
    return (
        <div className="row">
                {edges.map(({node: board}) => (
                    <div key={board.uuid} className="col-sm-6 col-md-6 col-lg-4">
                        <div className="card">
                            <div className="card-body">

                                <div className="text-primary">
                                    <h4><a href={`/board/${board.uuid}`}>{board.topic}</a></h4>
                                </div>

                                {/*<div className="d-flex flex-row justify-content-between">*/}
                                {/*    <div className="text-primary">*/}
                                {/*        <h4><a href={`/board/${board.uuid}`}>{board.topic}</a></h4>*/}
                                {/*    </div>*/}
                                {/*    <div>*/}
                                {/*        <TimeAgo date={board.created} className="text-muted"/>*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                                <div className="text-muted">
                                    {board.description}
                                </div>

                                {/*<div className="py-2 text-muted">*/}
                                {/*</div>*/}

                                <div className="text-muted py-3">
                                    <div className="text-muted">
                                        {/*#{board.slackChannelName}*/}
                                        <Count
                                            count={board.questionCount}
                                            singular="question"
                                            plural="questions"
                                            iconClassName="fa fa-comments"
                                        />
                                    </div>
                                </div>

                                <div className="d-flex flex-row align-items-center justify-content-between">
                                    <div className="text-muted">
                                        {board.creator.slackRealName} in #{board.slackChannelName}
                                    </div>
                                    <TimeAgo date={board.created} className="text-muted"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    ))}

            {pageInfo.hasNextPage ? (
                <div className="col-lg-4 offset-lg-4 text-center">
                    <button className="btn btn-primary" onClick={onLoadMore}>
                        Show more
                    </button>
                </div>
            ) : null}
        </div>
    )
}

Boards.propTypes = {
    edges: PropTypes.array.isRequired,
    pageInfo: PropTypes.object.isRequired,
    onLoadMore: PropTypes.func.isRequired,
}

export default Boards



// WEBPACK FOOTER //
// ./src/components/Boards.jsx